(function($){
    $(document).ready(function(e){
        $('.mt-2 .active').next('.nav-treeview').slideDown(500);
    })
})(jQuery);